import script from "./noticeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./noticeDialog.vue?vue&type=script&setup=true&lang=js"

import "./noticeDialog.vue?vue&type=style&index=0&id=146ed05b&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-146ed05b"]])

export default __exports__